import { SAPopover } from '@saux/design-system-react';
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { PLUS, REJOIN_CHAT, REMOVE_FROM_CHAT } from '../../utils/constants';
import avatar_qtuser from '../../icons/Union.png';
import "./avatar.css";

const AvatarComponent = styled.div`
    height: 40px;
    width: 40px;
    border-radius: 50%;
    margin-right: 10px;
    margin-left: 10px;
    background-color: #3E5572;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
`;




export default function Avatar(props: any) {

    const user = useSelector((state: any) => state.user)

    const [referenceElement, setReferenceElement] = useState<Element | null>(null);
    function handleClick(event: React.MouseEvent<HTMLElement>) {
        if (props.symbol === PLUS) {
            props.addAdjuster(false);
            return;
        }
        if (props.adjusterId === user.email) {
            setReferenceElement(event.currentTarget);
            if (props.hidetooltip) {
                props.hidetooltip();
            }
        }
    }
    function handleClose(event: React.MouseEvent<HTMLElement> | MouseEvent, index: number | null) {
        setReferenceElement(null);
        if (index === 0 && props.items[0] === REMOVE_FROM_CHAT) {
            props.deleteParticipant(props.id);
        }
        else if (index === 0 && props.items[0] === REJOIN_CHAT) {
            props.addAdjuster(true);
        }
    }
    let names = props.name && props.name.split(" ");
     let avatar_qt;
    if (props.name === 'QT_USER') {
        names = [];
         avatar_qt = avatar_qtuser
    }
    return (
        <>   
            {props.name  && <AvatarComponent className={props.name !== 'QT_USER' ? 'normal-user': 'qt-user'} style={props.name !== 'QT_USER' ? props.style : {background: "#48C1FF"}} onClick={handleClick} data-testid="avatarComponent">
                                                <span style={{ fontWeight: "bold", fontSize: props.fontSize ? props.fontSize : 14, marginBottom: props.marginBottom || 0 }}>
                                                { props.name === 'QT_USER' && avatar_qt && <img src={avatar_qtuser} alt="logo_mobile" style={props.style} />} 
                                                { props.name !== 'QT_USER' && <>
                                                    {names && names[0] && names[0][0].toUpperCase()}
                                                    {names && names[1] && names[1][0].toUpperCase()}
                                                    </>
                                                }
                                                    {props.symbol}
                                                </span>
                                                </AvatarComponent>} 

                                               
            {!props.name  &&  <AvatarComponent style={props.style} onClick={handleClick} data-testid="avatarComponent">
                <span style={{ fontWeight: "bold", fontSize: props.fontSize ? props.fontSize : 14, marginBottom: props.marginBottom || 0 }}>
                    {names && names[0] && names[0][0].toUpperCase()}
                    {names && names[1] && names[1][0].toUpperCase()}
                    {props.symbol}
                </span>
            </AvatarComponent> }   
            {props.items && <SAPopover
                data={props.items}
                onClose={(e: MouseEvent, index: number | null) => handleClose(e, index)}
                placement="bottom-start"
                referenceElement={referenceElement}
                variant="popover-menu"
            />}
        </>
    )
}
